import { render, staticRenderFns } from "./ListAnggaran.vue?vue&type=template&id=a748197e&"
import script from "./ListAnggaran.vue?vue&type=script&lang=js&"
export * from "./ListAnggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports